<template>
    <img 
        v-if="typeComponent == 'Single'" 
        :src="srcComponent" 
        :class="classes" 
        :style="styles" 
        @error="loadPlaceholder" 
        :height="height"
    /> 
    <v-img 
        v-else 
        :src="srcComponent" 
        :class="classes" 
        :style="styles" 
        @error="loadPlaceholder" 
        :height="height"
    ></v-img>
</template>

<script>
import { VImg } from 'vuetify/lib';

export default {
    components: {
        VImg
    },
    props: { 
        src: String, 
        classes: String, 
        styles: [String, Object], 
        typeComponent: String, 
        urlImage: String, 
        height: {
            type: [String, Number],
            default: "auto"
        }
    },
    data() {
        return {
            srcComponent: "",
            bandSrc: true
        }
    },
    methods: {
        loadPlaceholder() {
            this.srcComponent = this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER');
        }
    },
    mounted() {
        //console.log('this.urlImage',this.urlImage);
        if((this.urlImage || "").length > 0) {
            this.srcComponent = this.src;
        } else {
            this.srcComponent = this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER');
        }
    },
    watch: {
        src() {
            //console.log('this.urlImage',this.urlImage);
            if((this.urlImage || "").length > 0) {
                this.srcComponent = this.src;
            } else {
                this.srcComponent = this.$store.getters.env.get('VUE_APP_IMAGE_PLACEHOLDER');
            }
        }
    }
}
</script>